import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(e) { return { error: e }; }
  render() {
    if (this.state.error) {
      const isDev = process.env.NODE_ENV !== "production";
      return (
        <div style={{minHeight:"100vh",background:"#0a0f1e",display:"flex",alignItems:"center",
          justifyContent:"center",fontFamily:"monospace",padding:24}}>
          <div style={{maxWidth:600,background:"#1e293b",border:"1px solid #ef4444",borderRadius:12,padding:24}}>
            <div style={{color:"#ef4444",fontWeight:700,fontSize:16,marginBottom:12}}>Something went wrong</div>
            <pre style={{color:"#fca5a5",fontSize:12,whiteSpace:"pre-wrap",wordBreak:"break-all"}}>
              {isDev
                ? `${this.state.error.message}\n\n${this.state.error.stack}`
                : "An unexpected error occurred. Please reload the page to continue."}
            </pre>
            <button
              onClick={() => window.location.reload()}
              style={{marginTop:16,background:"#1d4ed8",color:"white",border:"none",
                borderRadius:7,padding:"8px 18px",fontSize:13,cursor:"pointer",fontFamily:"inherit"}}>
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
